import Poptip from './poptip.vue';
import directive from './directive';
Poptip.directive = directive;
export default Poptip;



// WEBPACK FOOTER //
// ./src/components/poptip/index.js